import { render, staticRenderFns } from "./msgReplyForm.vue?vue&type=template&id=2694d5ed&scoped=true"
import script from "./msgReplyForm.vue?vue&type=script&lang=js"
export * from "./msgReplyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2694d5ed",
  null
  
)

export default component.exports